// extracted by mini-css-extract-plugin
module.exports = {"oauthBtn":"_713c","oauthBtnText":"_3128","binded":"a5a2","icon":"_96f6","google":"_37ab","facebook":"_4bf0","line":"ed98"};